export const beneficiaryVo = {
    searchCode: '', // 類型(目前無使用)
    order: '', // 順位 如'01'、'02'
    isDivide: '', // 均分否 Y or N
    dividKind: '', // 分紅/分享金方式(目前無使用)
    dividKindDesc: '', // 分紅/分享金方式說明(目前無使用)
    name: '', // 姓名
    engName: '', // 英文譯音(目前無使用)
    id: '', // 受益人ID
    birthday: '', // 生日
    country: '中華民國', // 國籍
    relation: '', // 關係_中文
    percent: '', // 比例-分子
    proportionDenominator: '100', // 比例-分母
    bankNo: '', // 銀行代碼
    swiftCode: '', // SWIFT-CODE(目前無使用)
    branchCode: '', // 分行代碼
    branchName: '', // 分行名稱
    bankName: '', // 銀行中文
    account: '', // 銀行帳號
    city: '',// 縣市
    cityArea: '',// 區
    address: '',// 地址
    mobile: '',// 行動電話
}

export const inputFields = [
    {
        id: 'name',
        name: '姓名',
        key: '姓名',
        placeholder: '請填寫姓名',
        type: 'text',
        value: '',
        errorMassage: '',
        CheckVisible: false,
        showType: ['005_01', '005_02', '005_03'],
    },
    {
        id: 'engName',
        name: '英文姓名',
        key: '英文姓名',
        placeholder: '請填寫英文姓名',
        type: 'text',
        value: '',
        errorMassage: '',
        showType: ['005_01', '005_02', '005_03'],
    },
    {
        id: 'id',
        name: '身分證字號',
        key: '身分證字號',
        placeholder: '請輸入身分證字號',
        type: 'text',
        value: '',
        errorMassage: '',
        showType: ['005_01', '005_02', '005_03'],
    },
    {
        id: 'country',
        name: '國籍',
        key: '國籍',
        value: '中華民國',
        type: 'text',
        errorMassage: '',
        disabled: true,
        showType: ['005_01', '005_02', '005_03'],
    },
    {
        id: 'birthday',
        name: '出生日期',
        key: '出生日期',
        placeholder: '請輸入出生日期',
        type: 'calendar',
        value: '',
        errorMassage: '',
        beginDate: '',
        isYearROC: true,
        isOpenCalendar: false,
        showType: ['005_01', '005_02', '005_03'],
    },
    {
        id: 'relation',
        name: '與被保險人的關係',
        key: '與被保險人的關係',
        placeholder: '請選擇與被保險人的關係',
        type: 'select',
        options: [],
        value: '',
        errorMassage: '',
        showType: ['005_01', '005_02', '005_03'],
    },
    {
        id: 'accountGroup',
        name: '受益人匯款帳號 (非必填)',
        key: '受益人匯款帳號',
        type: 'bankAccount',
        value: {
            'bankCode': '',
            'bankBranch': '',
            'bankAccount': ''
        },
        errorMassage: '',
        showType: ['005_02', '005_03'],
    },
    {
        id: 'addressGroup',
        name: '聯絡地址(非必填)',
        key: '聯絡地址',
        type: 'address',
        value: {
            'city': '',
            'cityArea': '',
            'address': '',
        },
        errorMassage: '',
        showType: ['005_01'],
    },
    {
        id: 'mobile',
        name: '行動電話(非必填)',
        key: '行動電話',
        type: 'text',
        value: '',
        errorMassage: '',
        showType: ['005_01'],
    },
    {
        id: 'ratio',
        name: '分配比例',
        key: '受益人分配比例',
        placeholder: '請填寫分配比例',
        value: '',
        errorMassage: '',
        isVisible: false,
        showType: ['005_01', '005_02', '005_03'],
    },
]

// 初始受益人欄位
export const beneficiaryField = {
    isComplete: false,
    isOpen: true,
    fields: inputFields,
    apiData: beneficiaryVo
};
